import React, { lazy, Suspense } from "react";
import MediaQuery from "react-responsive";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WhyYouNeedDenise from "./components/subPages/WhyYouNeedDenise";
import KeyReasons from "./components/subPages/KeyReasons";
import Debunking from "./components/subPages/DebunkingMortgageMyths";
import CreditTips from "./components/subPages/CreditTips";
import FAQ from "./components/subPages/FAQ";
import "@fontsource/poppins";
import "@fontsource/great-vibes";
import "./App.css";
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import { CookieSetting } from "cookiesetting-component";


const Welcome = lazy(() => import("./components/Welcome"));
const Info = lazy(() => import("./components/Info"));
const Highlights = lazy(() => import("./components/Highlights"));
const Footer = lazy(() => import("./components/Footer"));
const ScrollToTop = lazy(() => import("./components/ScrollToTop"));

function Home() {
  const imgCDNURL = process.env.REACT_APP_MYDIVORCELENDER_CDN_URL;
  const appVersion = appversion.version;

  return (
    <>
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        metaFileDirectory={process.env.PUBLIC_URL}
      >
        <main id="app">
          <MediaQuery minWidth={992}>
            <img
              src={imgCDNURL + "bgrec.webp"}
              className="img-fluid bgrecwelcome"
            />
            <img
              src={imgCDNURL + "bgwelcome.png"}
              className="img-fluid bgwelcome"
            />
            <img
              src="https://d2w24n4g34usfg.cloudfront.net/time2buy/background-lines.png"
              class="body-bg-lines img-fluid"
            ></img>
          </MediaQuery>
          <Suspense fallback={<div />}>
            <Welcome />
          </Suspense>
          <MediaQuery minWidth={992}>
            <img
              src={imgCDNURL + "vectorserveleft.webp"}
              className="img-fluid vectorserveleft"
            />
            <img
              src={imgCDNURL + "vectorserveright.webp"}
              className="img-fluid vectorserveright"
            />
            <img
              src={imgCDNURL + "bgdoc.webp"}
              className="img-fluid bgdocserve"
            />
            <img
              src={imgCDNURL + "bgrec.webp"}
              className="img-fluid bgrecserve"
            />
            <img src={imgCDNURL + "wtcdlp.webp"} className="img-fluid wtcdlp" />
            <img
              src={imgCDNURL + "breakheartcdlp.webp"}
              className="img-fluid breakheartcdlp"
            />
            <img
              src={imgCDNURL + "clipcdlp.webp"}
              className="img-fluid clipcdlp"
            />
            <img
              src={imgCDNURL + "vectorserveright.webp"}
              className="img-fluid vectorcdlprights"
            />
            <img
              src={imgCDNURL + "vectorhighlight.webp"}
              className="img-fluid vectorresources"
            />
          </MediaQuery>
          <Suspense fallback={<div />}>
            <Info />
          </Suspense>
          <MediaQuery minWidth={992}>
            <img src={imgCDNURL + "bgdoc.webp"} className="img-fluid bgdoc" />
            <img src={imgCDNURL + "bgrec.webp"} className="img-fluid bgrec" />
            <img
              src={imgCDNURL + "vectoraboutme.webp"}
              className="img-fluid vectoraboutme"
            />
            <img
              src={imgCDNURL + "vectorhighlight.webp"}
              className="img-fluid vectorhighlight"
            />
          </MediaQuery>
          <Suspense fallback={<div />}>
            <Highlights />
          </Suspense>
          <Suspense fallback={<div />}>
            <ScrollToTop />
          </Suspense>
          <Suspense fallback={<div />}>
            <Footer />
          </Suspense>
        </main>
      </CacheBuster>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes  >
        <Route exact path="/" element={<Home />} />
        <Route exact path="/mydivorcelender" element={<Home />} />
        <Route
          exact
          path="/mydivorcelender/whyyouneeddenise"
          element={<WhyYouNeedDenise />}
        />
        <Route
          exact
          path="/mydivorcelender/keyreasons"
          element={<KeyReasons />}
        />
        <Route
          exact
          path="/mydivorcelender/debunking-mortgage-myths"
          element={<Debunking />}
        />
        <Route
          exact
          path="/mydivorcelender/credit-tips-during-divorce"
          element={<CreditTips />}
        />
        <Route exact path="/mydivorcelender/FAQ" element={<FAQ />} />
      </Routes>
      <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    </BrowserRouter>
  );
}
